import React from 'react'
import ExperiencePageTrendingDestinations from './ExperiencesPageTrendingDestinations'
import GlobalSearchContainerPane, { GlobalSearchContainerPaneContent } from 'components/Search/GlobalSearch/GlobalSearchContainerPane'
import GlobalSearchHeroContainer from 'components/Search/GlobalSearch/GlobalSearchHeroContainer'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import GlobalMobileSearchHeroBar from 'components/SearchV2/Components/Mobile/GlobalMobileSearchHeroBar'
import config from 'constants/config'
import { destinationsMap } from 'constants/experience'
import ExperienceSearchForm from '../ExperiencesSearch/ExperienceSearchForm'

const SearchHero = styled(GlobalSearchHeroContainer)`
  ${mediaQueryUp.tablet} {
    padding: ${rem(40)} 0 ${rem(60)} 0;
  }
`

const ExperiencePageSearchHeader = React.forwardRef<HTMLDivElement>((props, ref) => {
  const destinations = destinationsMap(config.BRAND)
  const trendingDestinationsLabels = destinations.map(destination => destination.name)

  return (
    <SearchHero
      ref={ref}
      heroImageId="nz83bzbyhxc8r1b8t8m"
      title="Find the perfect experience in any destination"
    >
      <GlobalSearchContainerPane>
        <GlobalSearchContainerPaneContent>
          <ExperienceSearchForm />
        </GlobalSearchContainerPaneContent>
      </GlobalSearchContainerPane>
      <GlobalMobileSearchHeroBar
        placeholder="Search great experiences in"
        placeholderTextList={trendingDestinationsLabels}
      />
      <ExperiencePageTrendingDestinations />
    </SearchHero>
  )
})

ExperiencePageSearchHeader.displayName = 'ExperiencePageSearchHeader'

export default ExperiencePageSearchHeader
